import { network } from 'services/network';

export const createProject = (params) => {
    return network.post('api/bo/management/createProject', params).then((response) => {
        return response.data;
    });
};
